import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';

export const pdfService = {
  authorizedCert: (
    certificateNr: string | undefined,
    sn: number | '' | undefined
  ) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/authorized`,
        { certificateNr, sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  originalCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/original`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  worksTestCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/works-test`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  typeApprovalCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/type-approval`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  dnvCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/dnv`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  docCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/doc`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  docUkCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/doc-uk`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  uscgCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/uscg`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  modulB: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/modul-b`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  modulD: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/modul-d`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  modulBUkca: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/modul-b-ukca`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  modulDUkca: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/modul-d-ukca`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
  ccsCert: (sn: number | undefined) =>
    axiosService
      .post(
        `${AXIOS_URLS.pdf_certificates}/ccs`,
        { sn },
        {
          responseType: 'blob',
        }
      )
      .then((res) => res.data),
};
